export type PaymentMethod = 'wireTransfer' | 'directDebit' | 'card';

export const defaultPaymentMethod: PaymentMethod = 'wireTransfer';
